import React from "react";

import "./style.scss";
import Helmet from "./common/helmet";
import NavBar from "./common/navbar";
import SubMenu from "./common/submenu";
import Extraescolares from "./layouts/extraescolares/extraescolares";
import Footer from "./common/footer";

const Layout = ({ children }) => (
  <div>
    <Helmet />
    <SubMenu />
    <NavBar />
    <Extraescolares />
    <Footer />
  </div>
);

export default Layout;
